<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text text-center">
                    <h1>About</h1>
                    <!-- <ul>
                        <li>
                            <a href="index.php"><span>Home</span></a>
                        </li>
                        <li><a href="chairmans-desk.php">About</a></li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm about-us section-banner-bg-1">
    <div class="container">
        <div class="row g-3 row-cols-1 row-cols-lg-2 justify-content-between align-items-start">
            <div class="col-lg-12">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                            aria-selected="true">About Foundation</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                            aria-selected="false">Advisory Board</button>
                    </li>
                    <!-- <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                            aria-selected="false">About The Founder</button>
                    </li> -->
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                            aria-selected="false">About Team</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-mission-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-mission" type="button" role="tab" aria-controls="pills-mission"
                            aria-selected="false">Vision & Mission</button>
                    </li>
                </ul>
            </div>
            <div class="col-lg-12">
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                        aria-labelledby="pills-home-tab">
                        <div class="widget_title inner-title">
                            <h4>ABOUT FOUNDATION</h4>
                        </div>
                        <p class="text-justify">G H Raisoni Sports & Cultural Foundation GHRSCF is established in the
                            year 2011 and is incorporated under Section 25 of Companies Act 1956 (No. 1 of 1956)
                            (Revised Section 8 of Companies act 2013).</p>
                        <p class="text-justify">
                            GHRSCF will embrace the benefits of Culture and Sport, recreation and fitness in building a
                            healthy community and developing lifelong connections to the Society, Students and will
                            support the provision of quality
                            facilities and programmes, it has started taking steps towards the sustainable development.
                            GHRSCF is an undertaking of Raisoni Education and is aligned to the Vision and Mission of
                            Raisoni Education.
                        </p>
                        <p class="text-justify">
                            SPORTS & CULTURE in the broadest understanding of the term means the totality of all
                            Physical, Mental, spiritual, material, intellectual and emotional features of a society or
                            social group and alongside Sports,
                            Games, art and literature includes also the way of life, ways of co-existence, systems of
                            values, traditions and views. When assessing the role of sports & culture in the life of
                            each state and community, it is
                            important not to impose limits upon it, judging about it only as to its as to its
                            applicability, but to foster the development of each individual’s creative potential and
                            participation in the processes. Sports &
                            Culture not only brings social cohesion to society, but also educates, enriching the process
                            of life-long education with new informal possibilities for the growth of personality.
                        </p>
                        <div class="widget_title inner-title">
                            <h4>BASIC OBJECTIVES OF G H RAISONI SPORTS & CULTURAL FOUNDATION</h4>
                        </div>
                        <ul class="list-style list-style1">
                            <li>Providing the right forms of support and recognition for Athletes Sports persons and
                                individual artists is an important element of this Foundation.</li>
                            <li>
                                This includes pathways from school and university to work, opportunities for emerging
                                sports persons & artists to get a foothold, opportunities for mid-career people to
                                consolidate and recognition of the
                                lifetime contribution of eminent in all fields.
                            </li>
                            <li>
                                All our activities aim to increase Sports, Arts and culture professionals’ interaction
                                between RGI and the target population. (This is grass-roots work almost at the level of
                                individuals, and its effects may
                                not be visible for years but will provide the great foundation for the future to come.)
                            </li>
                            <li>
                                All the institute’s projects aim to increase the professional competence. It depends on
                                the project whether this increasing competence relates to content (e.g. artistic work)
                                or career development (networks,
                                country-specific sector knowledge).
                            </li>
                            <li>To provide learning experience to all.</li>
                            <li>To put new emphasis and to define the directions of strategic development within the
                                development of Indian Sports and Culture policy.</li>
                        </ul>
                    </div>
                    <!-- <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                        <div class="widget_title inner-title">
                            <h4>ABOUT THE FOUNDER</h4>
                        </div>
                        <div class="fide-chess-text">
                            <p>
                                Sunil Gyanchandji Raisoni <br />
                                The Founder of GHR Sports & Cultural Foundation.
                            </p>
                        </div>
                        <div class="row text-justify">
                            <div class="col-md-8">
                                <p>
                                    He is popularly known for his inclination towards enhancing Sports and Cultural
                                    activities in the Society and Raisoni Education all together. He is an Intellectual
                                    and a tenacious
                                    philanthropist who was born in Jalgaon, Maharashtra on 11th December 1961.
                                </p>
                                <p>
                                    He is a scholar himself and is following a legacy of Philanthropy passed by his
                                    father Late Shri. Gyanchandji Raisoni. He always believed in the philosophy of
                                    appreciating work and dedication of a person
                                    than personality cult. He is a futuristic person who believes in implementing ways
                                    to support various social reforms that addresses our nation’s developmental
                                    challenges.
                                </p>
                                <p>
                                    With his hard work, Dedication and commitment towards his dreams he came up with
                                    various roles and succeeded in whatever he decided. He is committed to enhance the
                                    quality of life through an integrated
                                    approach towards the various projects in the areas of Education, Environment, Health
                                    and Welfare activities…
                                </p>
                            </div>
                            <div class="col-md-4">
                                <div class="image-effect-3 mb-sm mb-5">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sunil-raisoni.jpg"
                                        alt="Founder | GHRSCF" />
                                    <div class="image-shape"></div>
                                </div>
                                <div class="text">
                                    <h6>Shri. Sunil Raisoni</h6>
                                    <p>The Founder of GHR Sports & Cultural Foundation</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                        <div class="widget_title inner-title">
                            <h4>ADVISORY BOARD</h4>
                        </div>

                        <div class="row row-cols-lg-4 justify-content-center align-items-center text-justify">

                            <div class="col">
                                <div class="team-pattern-2">
                                    <img loading="lazy" decoding="async"
                                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/team/sunil-raisoni.webp"
                                        class="img-fluid w-100" alt="Shri. Sunil Raisoni | Raisoni Education">
                                    <div class="team-details text-center">
                                        <h5 class="fw-bold">Shri. Sunil Raisoni</h5>
                                        <!-- <p class="mb-0">Chairman</p> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="team-pattern-2">
                                    <img loading="lazy" decoding="async"
                                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/team/shobha-raisoni.webp"
                                        class="img-fluid w-100" alt="Smt. Shobha Raisoni | Raisoni Education">
                                    <div class="team-details text-center">
                                        <h5 class="fw-bold">Smt. Shobha Raisoni</h5>
                                        <!-- <p class="mb-0">Patron</p> -->
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                        <div class="widget_title inner-title">
                            <h4>ABOUT TEAM</h4>
                        </div>
                        <div class="categories-area">
                            <div
                                class="row g-3 row-cols-1 row-cols-sm-2 row-cols-lg-3 justify-content-center align-items-center">
                                <div class="col ">
                                    <div class="cat-item shadow-soft">
                                        <h3 class="text-center"> Seema Vivek Wanjari</h3>
                                        <p class="text-center"> Director </p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="cat-item shadow-soft">
                                        <h3 class="text-center">Aarti Pradyumna Deshpande </h3>
                                        <p class="text-center">Director</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="cat-item shadow-soft">
                                        <h3 class="text-center">Dr. Mrunalini Naik</h3>
                                        <p class="text-center">Director</p>
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="cat-item shadow-soft">
                                        <h3 class="text-center">Indrajeet Singh Randhawa </h3>
                                        <p class="text-center">Physical Director</p>
                                        <p class="text-center">G H Raisoni College of Engineering, Nagpur</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="cat-item shadow-soft">
                                        <h3 class="text-center">Mr. Amit Gandhare</h3>
                                        <p class="text-center">PR Director</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="cat-item shadow-soft">
                                        <h3 class="text-center"> Mr Akhil Rambhad</h3>
                                        <p class="text-center">Sports Coordinator</p>
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="cat-item shadow-soft">
                                        <h3 class="text-center">Shubhangi Thakre</h3>
                                        <p class="text-center">Executive</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="cat-item shadow-soft">
                                        <h3 class="text-center">Deepali Poriaya</h3>
                                        <p class="text-center">Executive</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-mission" role="tabpanel" aria-labelledby="pills-mission-tab">
                        <div class="widget_title inner-title">
                            <h4>MISSION & VISSION</h4>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="main-timeline">
                                    <div class="timeline">
                                        <a href="#" class="timeline-content">
                                            <div class="timeline-icon">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/mission.png"
                                                    alt="Mission | GHRSCF" class="img-fluid" />
                                            </div>
                                            <h3 class="title">MISSION</h3>
                                            <p class="description text-justify">
                                                Our efforts are dedicated to imbibe the way of life through Sports &
                                                Culture in society. Our endeavor is to support and strengthen the Sports
                                                & Cultural environment and contribute to
                                                enhancement of such activities in society.
                                            </p>
                                        </a>
                                    </div>
                                    <div class="timeline">
                                        <a href="#" class="timeline-content">
                                            <div class="timeline-icon">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/vision.png"
                                                    alt="Vision | GHRSCF" class="img-fluid" />
                                            </div>
                                            <h3 class="title">VISION</h3>
                                            <p class="description text-justify">
                                                To provide farsighted active platform for promoting initiatives in the
                                                sphere of Sports and Culture.
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
